"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Pluralize a string
 * @param str The string to pluralize
 * @return The pluralized string
 */
function pluralize(str) {
    if (str.endsWith('y')) {
        return str.slice(0, -1) + "ies";
    }
    if (str.endsWith('s')) {
        return str.slice(0, -1) + "ses";
    }
    if (str.endsWith('x')) {
        return str.slice(0, -1) + "xes";
    }
    return str + "s";
}
exports.pluralize = pluralize;
//# sourceMappingURL=utils.js.map